/* Colourway swatches on product cards — see snippets/colourways.liquid.
   Hover a dot: preview that colourway on the card. Click a dot: select it
   (image, title, price and card link switch, ring moves) without leaving
   the page. Click the card: open the selected colourway. Product-page dots
   are plain links and need nothing from here. Delegated once per page. */
(function () {
  'use strict';
  if (window.__nxColourways) return;
  window.__nxColourways = true;

  function rowOf(el)   { return el.closest ? el.closest('.cw--card') : null; }
  function cardOf(row) { return row.closest('a.card, a.lx-card, a.noc-card'); }
  function q(card, sel){ return card.querySelector(sel); }

  function remember(card) {
    if (card.dataset.cwKept) return;
    card.dataset.cwKept = '1';
    var img = q(card, '.card__frame img, .lx-paper img, img.noc-card__flat');
    if (img) {
      img.dataset.cwSrc0 = img.getAttribute('src') || '';
      img.dataset.cwSrcset0 = img.getAttribute('srcset') || '';
      img.dataset.cwAlt0 = img.getAttribute('alt') || '';
    }
    var name = q(card, '.card__name, .lx-name, .noc-card__name'), price = q(card, '.card__price, .lx-price, .noc-card__price');
    if (name) name.dataset.cwText0 = name.textContent;
    if (price) price.dataset.cwText0 = price.textContent;
  }

  /* Show `dot` on its card. The product's own dot carries only a link, so it
     restores exactly what Liquid rendered; a sibling with no photo keeps the
     original image but still switches link, title and price. */
  function show(dot) {
    var row = rowOf(dot); if (!row) return;
    var card = cardOf(row); if (!card) return;
    remember(card);
    if (dot.dataset.cwHref) card.setAttribute('href', dot.dataset.cwHref);
    var img = q(card, '.card__frame img, .lx-paper img, img.noc-card__flat');
    if (img) {
      if (dot.dataset.cwSrc) {
        img.setAttribute('src', dot.dataset.cwSrc);
        if (dot.dataset.cwSrcset) img.setAttribute('srcset', dot.dataset.cwSrcset); else img.removeAttribute('srcset');
        if (dot.dataset.cwAlt) img.setAttribute('alt', dot.dataset.cwAlt);
      } else {
        img.setAttribute('src', img.dataset.cwSrc0);
        if (img.dataset.cwSrcset0) img.setAttribute('srcset', img.dataset.cwSrcset0); else img.removeAttribute('srcset');
        img.setAttribute('alt', img.dataset.cwAlt0);
      }
    }
    var name = q(card, '.card__name, .lx-name, .noc-card__name'), price = q(card, '.card__price, .lx-price, .noc-card__price');
    if (name)  name.textContent  = dot.dataset.cwTitle || name.dataset.cwText0;
    if (price) price.textContent = dot.dataset.cwPrice || price.dataset.cwText0;
  }
  function selected(row) { return row.querySelector('.cw__dot.is-selected') || row.querySelector('.cw__dot'); }
  function setHover(row, dot) {
    var dots = row.querySelectorAll('.cw__dot');
    for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-hover', dots[i] === dot);
  }

  var canHover = !!(window.matchMedia && window.matchMedia('(hover: hover)').matches);

  /* hover = temporary preview */
  document.addEventListener('pointerover', function (e) {
    if (!canHover || !e.target.closest) return;
    var dot = e.target.closest('.cw--card .cw__dot'); if (!dot) return;
    setHover(rowOf(dot), dot); show(dot);
  }, true);

  /* leaving the row = back to whatever is selected */
  document.addEventListener('pointerout', function (e) {
    if (!canHover || !e.target.closest) return;
    var row = e.target.closest('.cw--card'); if (!row) return;
    if (e.relatedTarget && row.contains(e.relatedTarget)) return;
    setHover(row, null); show(selected(row));
  }, true);

  /* click a dot = select it (sticky). preventDefault keeps the card link from
     following; noctura-transitions.js already ignores defaultPrevented clicks. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var dot = e.target.closest('.cw--card .cw__dot'); if (!dot) return;
    e.preventDefault();
    var row = rowOf(dot), dots = row.querySelectorAll('.cw__dot');
    for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-selected', dots[i] === dot);
    setHover(row, null); show(dot);
  }, true);
})();
